import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { setLoginForwardUrl } from 'actions/LoginActions';

import ModalAccountTermsAndPrivacyPolicy from 'components/modals/ModalAccountTermsAndPrivacyPolicy';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';
import ModalMarketplaceTermsOfService from 'components/modals/ModalMarketplaceTermsOfService';
import ModalOrderProcessingContract from 'components/modals/ModalOrderProcessingContract';

class Account extends React.Component {
  componentWillMount = () => {
    const { appIntl, location, history, user, setLoginForwardUrl, doChangeLocale } = this.props;

    if (user?.logged) {
      if (user?.lang?.main_language !== undefined && appIntl?.locale !== undefined) {
        if (user?.lang?.main_language !== appIntl?.locale) {
          this.setState({ changeLang: false });
          doChangeLocale(user?.lang?.main_language);
        }
      }
    }

    if (!user.logged && !user.adhocLogout) {
      setLoginForwardUrl(location.pathname);
      history.push(appIntl.urlPrefix + 'login');
    }
  };

  componentDidUpdate = prevProps => {
    const { appIntl, location, history, user, setLoginForwardUrl, doChangeLocale } = this.props;
    // if the user is not logged in, then redirect him to the login page
    if (!user.logged && !user.adhocLogout && !prevProps.user.adhocLogout) {
      if (!prevProps.user.logged) {
        setLoginForwardUrl(location.pathname);
      }
      history.push(appIntl.urlPrefix + 'login');
    }
  };

  render() {
    const {
      intl: { messages },
      user,
      children,
    } = this.props;

    const {
      has_accepted_terms_and_conditions: acceptedTermsConditions,
      has_accepted_terms_of_use: acceptedTermsUse,
      has_accepted_order_processing_contract: acceptedProcessingContract,
    } = user;

    return (
      <DocMeta tags={generateMetaTags(messages.meta.account)}>
        {user.logged ? (
          <div class="content">
            <ModalAccountTermsAndPrivacyPolicy show={!acceptedTermsConditions} />
            <ModalMarketplaceTermsOfService show={acceptedTermsConditions && !acceptedTermsUse} />{' '}
            {/* is Marketplace Terms of Use */}
            <ModalOrderProcessingContract
              show={acceptedTermsConditions && acceptedTermsUse && !acceptedProcessingContract}
            />
            {children}
          </div>
        ) : null}
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    appIntl: state.intl,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setLoginForwardUrl: forwardUrl => {
      dispatch(setLoginForwardUrl(forwardUrl));
    },
    doChangeLocale: locale => {
      dispatch({
        type: 'CHANGE_LOCALE',
        payload: {
          locale,
        },
      });

      let newLocationPathname = ownProps.location.pathname.replace(/^\//, '');
      if (newLocationPathname.search(new RegExp('de/|pl/|en/|tr/|es/|fr/|it/|nl/')) === 0) {
        newLocationPathname = newLocationPathname.substr(3);
      }
      ownProps.history.replace('/' + locale + '/' + newLocationPathname);
    },
  };
};

export default injectIntl(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Account)
  )
);
